import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {BeatLoader} from 'react-spinners';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import Datetime from 'react-datetime';
import {_addNotification, _addNotificationError,isRegularLunchOrderType} from "../../../../server/util";
import MonthDropdown from '../../../Misc/MonthDropdown';
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import {getReportMenuOptions} from '../../../Misc/MenuOptions/menuOptionsActions';
import {MenuOrderTypes,MealTypesReports } from '../../../../server/constants';
import {Bar,Pie} from 'react-chartjs-2';
var _ = require('lodash');
const options={
    responsive: true,
    maintainAspectRatio: false,
    legend:{
        position:'left'
    },
    plugins: {
      datalabels: {
         display: true,
         font: { size: '10',weight: 'bold' },
      }
   }
}
var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
class OrderNotOrder extends Component {
    constructor(props){
        super(props);
        let date = new Date();
        date.setMonth(date.getMonth())
        this.state={
            loading:false,
            date: date,
            selectedMonth:(moment((this.props.activeMonth||moment()),'YYYYMM')||moment()).format('MMM-YYYY'),
            mealType:(getReportMenuOptions()[0]||''),
            activeMonth:null,
            chartObj: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [
                        '#84bed6',
                        '#b5d56a'
                    ],
                    hoverBackgroundColor: [
                        '#84bed6',
                        '#b5d56a'                        
                    ]
                }]
            } 
        }
        this.init=this.init.bind(this)
        this.getData=this.getData.bind(this);
    }
    componentWillMount=()=>{
        this.init();

    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.state.activeMonth!==nextProps.activeMonth){
            this.setState({
                selectedMonth: moment((nextProps.activeMonth||moment()),'YYYYMM').format('MMM-YYYY')
            },this.getData(nextProps.activeMonth))
        }
    }
    init=()=>{
        this.getData((moment((this.props.activeMonth||moment()),'YYYYMM')||moment()).format('YYYYMM'));
    }
    
    getData=()=>{
        let selectedMonthYear=moment(this.state.selectedMonth||moment().format('MMM-YYYY'),'MMM-YYYY').format('YYYYMM');
        //let yearMonth = (moment(this.state.date,'MM').format().split('-')[0])+ '' + (moment(this.state.date,'MM').format().split('-')[1]);
        if(this.state.mealType===MealTypesReports.LUNCH ||
            this.state.mealType===MealTypesReports.SNACK){
        //const mType=(this.state.mealType===MealTypesReports.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.state.mealType;                                                                                                                                                           
        get('/reports/countByGrade?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId')+ '&yearMonth=' + selectedMonthYear + '&menuType='+ this.state.mealType +'&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=').then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _chartObj=this.state.chartObj; 
            _chartObj.labels=['Ordered Students','Not Ordered Students'];
            _chartObj.datasets[0].data=[];
            let _orderCount=0;
            let _notOrderCount=0;
            Object.keys(orders).map((key)=>{
                if(key==='ordered'){
                    _orderCount=_orderCount+orders[key].allGradesCount;
                }
                if(key==='notOrdered'){
                    _notOrderCount=_notOrderCount+orders[key].allGradesCount;
                }
            })
            _chartObj.datasets[0].data.push(_orderCount);
            _chartObj.datasets[0].data.push(_notOrderCount);          
           // _chartObj.labels=[];
           // _chartObj.datasets[0].data=[];
          //  _chartObj.datasets[1].data=[];
            /* Object.keys(orders).map((key)=>{
                if(key==='ordered'){
                    _chartObj.datasets[0].data.push(orders[key].allGradesCount);
                }
                if(key==='notOrdered'){
                    _chartObj.datasets[1].data.push(orders[key].allGradesCount);
                }
            }) */
            this.setState({ chartObj:_chartObj,loading: false          
            })            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
    }
    }
    render(){
        return(<div>
         <NotificationSystem ref="notificationSystem"/>  
         <div className="col-md-4">  
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>   
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                <span className="panel-title" style={{fontSize: '14px', fontWeight:'600'}}>
                Ordered Vs Not Ordered</span>
                <div className="pull-right">
                <MonthDropdown dateFormat={'YYYYMM'} onChange={(e)=>{
                    this.setState({selectedMonth:moment(e).format('MMM-YYYY')},()=>{
                        this.getData(moment(e).format('YYYYMM'))
                    })                     
                }} selectedMonth={moment((this.state.selectedMonth||moment()),'MMM-YYYY')} />
                </div>
                <p>{this.state.selectedMonth}</p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>        
            <Pie data={this.state.chartObj} options={options} onElementsClick={(elems)=>{
                if(elems.length>0){
                        console.log(elems[0]._datasetIndex + ', ' + elems[0]._index);
                        let grade= '0';
                        let action= elems[0]._model.label=='Not Ordered Students'?'NotOrdered':'Ordered';
                        let selectedMonthYear=moment(this.state.selectedMonth||moment().format('MMM-YYYY'),'MMM-YYYY').format('YYYYMM');
                        this.props.onElementClick(grade,action,selectedMonthYear)
                     } 
            }} />
            </div>
            </div> 
        </div>
        </div>)
    }
}
export default OrderNotOrder


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/OrderVsNotorder.jsx